import { render, staticRenderFns } from "./PsCalendarGridMonth.vue?vue&type=template&id=0b80d978&scoped=true&"
import script from "./PsCalendarGridMonth.vue?vue&type=script&lang=js&"
export * from "./PsCalendarGridMonth.vue?vue&type=script&lang=js&"
import style0 from "./PsCalendarGridMonth.vue?vue&type=style&index=0&id=0b80d978&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b80d978",
  null
  
)

export default component.exports